import * as React from 'react';
import * as classNames from 'classnames';

export interface ITicketListTypeSelectorItem {
    title: string;
    path: string;
}

export interface ITicketListTypeSelector {
    items: ITicketListTypeSelectorItem[];
    activeIndex: number;
    onClick: (item: ITicketListTypeSelectorItem, index: number) => void;
}

export const TicketListTypeSelector: React.FC<ITicketListTypeSelector> = (props) => {
    return (<div className="ticket-list-type-selector">
        <ul className="tabs nav nav-tabs">
            {props.items.map((item, index) => <li className="nav-item" key={index}><a onClick={() => props.onClick(item, index)} className={classNames("tab nav-link", index === props.activeIndex ? "active" : undefined)}>
                {item.title}
                {index > 0 && <div className="separator"></div>}
            </a></li>)}
        </ul>
    </div >);
};